<template>
    <div class="blackout" v-if="data.active" @click="data.active = false">
        <div class="popup" @click.stop>
            <h1>Подтвердите операцию</h1>
            <p>Вы собираетесь оплатить {{ data.content }} песо</p>
            <div class="inline">
                <div class="button _free _accept" @click="$emit('confirm', data.content); data.active = false">Оплатить</div>
                <div class="button _free _decline" @click="data.active = false">Отмена</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['data', 'price']
    }
</script>